import { FC } from "react";
import { DsmProgressSteps } from "@dsm-dcs/design-system-react";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import { useHistory } from "react-router";
import { DsmProgressStepsCustomEvent } from "@dsm-dcs/design-system";
import { AnimalType } from "../../../../graphql/types";

interface SustellFarmStepsProps {
  active:string,
  completed?: Array<string>,
  onStepChange?: (e:any)=>void
  customerID?: string,
  farmID?:string | undefined,
  farmType?: AnimalType,
  processID?: string | undefined,
  datasetID?:string | undefined
};

export const SustellFarmSteps: FC<SustellFarmStepsProps> = (props) => {
  const intl = useIntl();
  const history = useHistory();

  const { 
    active, 
    completed, 
    onStepChange, 
    customerID,
    farmID,
    farmType,
    processID,
    datasetID
  } = props;
  const stepString = intl.formatMessage({ id: 'SUSTELL.STEP' });

  const steps = [
      { 
        id:"1",
        title:`${stepString} 1`,
        completed:completed?.some( item => item === "1") || false,
        description: intl.formatMessage({ id: "SUSTELL.BASELINE.DETAILS"}),
        farmType
      },
      { 
        id:"2",
        completed:completed?.some( item => item === "2") || false,
        title:`${stepString} 2`,
        description: intl.formatMessage({ id: "SUSTELL.STAGE.SELECTION"}),
        farmType
      },
      { 
        id:"3",
        completed:completed?.some( item => item === "3") || false,
        title:`${stepString} 3`,
        description:intl.formatMessage({id: "SUSTELL.STAGE.DETAILS"}),
        farmType
      }
    ];


  // replace any with DsmCustom
  const callStepChange = (e:DsmProgressStepsCustomEvent<string>)=>{
    // for first three steps it's fixed as they do a move to separate pages
    // console.log("called step change", e.detail)
    if(onStepChange)
        onStepChange(e.detail);
  }
  
  return (
    <DsmProgressSteps 
      steps={steps} 
      active-step={active} 
      style={{ marginTop: 'var(--dsm-spacing-px-16)'}}
      onDsmStepChange={ callStepChange }
    />
  );
};

export default SustellFarmSteps;